







import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../base/components/system/mixins";
import { StringFilter, StringFilterParameter } from "../../../../base/components/system/filters";
import { EditableFormatSummaryFilterParameter } from ".";

@Component({
  components: {
    StringFilter,
  },
})
export default class EditableFormatSummaryFilter extends Mixins(ModelEditableMixin) {
  readPropertyOrDefault: <T>(reader: (source: EditableFormatSummaryFilterParameter) => T, defaultValue: T) => T;
  writeProperty: (writer: (source: EditableFormatSummaryFilterParameter) => void) => void;

  get name(): StringFilterParameter {
    return this.readPropertyOrDefault(s => s.name, null);
  }

  set name(source: StringFilterParameter) {
    this.writeProperty(s => s.name = source);
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }
}
